var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189.51,
    height: 133.542,
    viewBox: "0 0 189.51 133.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_912",
    "data-name": "Grupo 912",
    transform: "translate(13126.755 -12850.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_scrum_board_re_wk7v",
    transform: "translate(-13126.755 12850.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15775",
    "data-name": "Trazado 15775",
    d: "M268.614,173.87H256.528a4.386,4.386,0,0,0-4.382,4.382v13.1c-.155-.009-.309-.023-.461-.042a15.453,15.453,0,1,1,16.86-17.9C268.57,173.561,268.593,173.716,268.614,173.87Z",
    transform: "translate(-226.62 -160.493)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15776",
    "data-name": "Trazado 15776",
    d: "M457.44,216.5H302.682a4.849,4.849,0,0,0-4.843,4.843v81.646a4.849,4.849,0,0,0,4.843,4.843H457.44a4.849,4.849,0,0,0,4.843-4.843V221.339A4.849,4.849,0,0,0,457.44,216.5Zm4.382,86.489a4.386,4.386,0,0,1-4.382,4.382H302.682a4.386,4.386,0,0,1-4.382-4.382V221.339a4.386,4.386,0,0,1,4.382-4.382H457.44a4.386,4.386,0,0,1,4.382,4.382Z",
    transform: "translate(-272.773 -203.579)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15777",
    "data-name": "Trazado 15777",
    d: "M490.6,272.326H351.069a.231.231,0,1,1,0-.461H490.6a.231.231,0,1,1,0,.461Z",
    transform: "translate(-313.549 -246.178)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15778",
    "data-name": "Trazado 15778",
    d: "M522.069,314.836a.231.231,0,0,1-.231-.231v-75.88a.231.231,0,1,1,.461,0v75.88A.231.231,0,0,1,522.069,314.836Z",
    transform: "translate(-445.11 -220.505)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15779",
    "data-name": "Trazado 15779",
    d: "M673.069,314.836a.231.231,0,0,1-.231-.231v-75.88a.231.231,0,1,1,.461,0v75.88A.231.231,0,0,1,673.069,314.836Z",
    transform: "translate(-561.284 -220.505)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15780",
    "data-name": "Trazado 15780",
    d: "M824.069,314.836a.231.231,0,0,1-.231-.231v-75.88a.231.231,0,1,1,.461,0v75.88A.231.231,0,0,1,824.069,314.836Z",
    transform: "translate(-677.458 -220.505)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15781",
    "data-name": "Trazado 15781",
    d: "M394.179,336.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V326a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,395.217,326v9.945A1.039,1.039,0,0,1,394.179,336.984Z",
    transform: "translate(-339.612 -287.03)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15782",
    "data-name": "Trazado 15782",
    d: "M446.179,459.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V449a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,447.217,449v9.945A1.039,1.039,0,0,1,446.179,459.984Z",
    transform: "translate(-379.619 -381.661)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15783",
    "data-name": "Trazado 15783",
    d: "M564.179,362.984h-8.427a1.039,1.039,0,0,1-1.038-1.038V352a1.039,1.039,0,0,1,1.038-1.038h8.427A1.039,1.039,0,0,1,565.217,352v9.945A1.039,1.039,0,0,1,564.179,362.984Z",
    transform: "translate(-470.404 -307.033)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15784",
    "data-name": "Trazado 15784",
    d: "M717.179,315.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V305a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,718.217,305v9.945A1.039,1.039,0,0,1,717.179,315.984Z",
    transform: "translate(-588.116 -270.873)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15785",
    "data-name": "Trazado 15785",
    d: "M858.179,315.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V305a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,859.217,305v9.945a1.039,1.039,0,0,1-1.038,1.038Z",
    transform: "translate(-696.596 -270.873)",
    fill: "#ffc42d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15786",
    "data-name": "Trazado 15786",
    d: "M923.179,327.984h-8.427a1.039,1.039,0,0,1-1.038-1.038V317a1.039,1.039,0,0,1,1.038-1.038h8.427A1.039,1.039,0,0,1,924.217,317v9.945A1.039,1.039,0,0,1,923.179,327.984Z",
    transform: "translate(-746.605 -280.106)",
    fill: "#5de280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15787",
    "data-name": "Trazado 15787",
    d: "M894.179,404.984h-8.427a1.039,1.039,0,0,1-1.038-1.038V394a1.039,1.039,0,0,1,1.038-1.038h8.427A1.039,1.039,0,0,1,895.217,394v9.945A1.039,1.039,0,0,1,894.179,404.984Z",
    transform: "translate(-724.293 -339.347)",
    fill: "#5de280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15788",
    "data-name": "Trazado 15788",
    d: "M770.179,388.984h-8.427a1.039,1.039,0,0,1-1.038-1.038V378a1.039,1.039,0,0,1,1.038-1.038h8.427A1.039,1.039,0,0,1,771.217,378v9.945A1.039,1.039,0,0,1,770.179,388.984Z",
    transform: "translate(-628.892 -327.037)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15789",
    "data-name": "Trazado 15789",
    d: "M699.179,404.984h-8.427a1.039,1.039,0,0,1-1.038-1.038V394a1.039,1.039,0,0,1,1.038-1.038h8.427A1.039,1.039,0,0,1,700.217,394v9.945A1.039,1.039,0,0,1,699.179,404.984Z",
    transform: "translate(-574.268 -339.347)",
    fill: "#5de280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15790",
    "data-name": "Trazado 15790",
    d: "M546.179,472.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V462a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,547.217,462v9.945A1.039,1.039,0,0,1,546.179,472.984Z",
    transform: "translate(-456.555 -391.663)",
    fill: "#5de280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15791",
    "data-name": "Trazado 15791",
    d: "M361.179,415.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V405a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,362.217,405v9.945A1.039,1.039,0,0,1,361.179,415.984Z",
    transform: "translate(-314.223 -347.81)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15792",
    "data-name": "Trazado 15792",
    d: "M464.179,336.984h-8.428a1.039,1.039,0,0,1-1.038-1.038V326a1.039,1.039,0,0,1,1.038-1.038h8.428A1.039,1.039,0,0,1,465.217,326v9.945A1.039,1.039,0,0,1,464.179,336.984Z",
    transform: "translate(-393.467 -287.03)",
    fill: "#5de280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15793",
    "data-name": "Trazado 15793",
    d: "M418.907,251.34H405.761a.923.923,0,1,1,0-1.845h13.146a.923.923,0,1,1,0,1.845Z",
    transform: "translate(-355.095 -228.968)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15794",
    "data-name": "Trazado 15794",
    d: "M579.907,251.34H566.761a.923.923,0,1,1,0-1.845h13.146a.923.923,0,0,1,0,1.845Z",
    transform: "translate(-478.962 -228.968)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15795",
    "data-name": "Trazado 15795",
    d: "M730.907,251.34H717.761a.923.923,0,1,1,0-1.845h13.146a.923.923,0,1,1,0,1.845Z",
    transform: "translate(-595.136 -228.968)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15796",
    "data-name": "Trazado 15796",
    d: "M871.907,251.34H858.761a.923.923,0,1,1,0-1.845h13.146a.923.923,0,1,1,0,1.845Z",
    transform: "translate(-703.616 -228.968)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15797",
    "data-name": "Trazado 15797",
    d: "M311.757,519.589a2.319,2.319,0,0,1-2.007-2.936l-5.912-5.5,3.126-.793,5.813,4.715a2.332,2.332,0,0,1-1.021,4.517Z",
    transform: "translate(-277.389 -429.665)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15798",
    "data-name": "Trazado 15798",
    d: "M184.4,529.871h2.828l1.345-10.906H184.4Z",
    transform: "translate(-141.872 -399.271)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15799",
    "data-name": "Trazado 15799",
    d: "M0,0H8.887V3.433H3.433A3.433,3.433,0,0,1,0,0Z",
    transform: "translate(50.811 133.226) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15800",
    "data-name": "Trazado 15800",
    d: "M100.345,522.244l2.733.727,4.106-10.193-4.033-1.073Z",
    transform: "translate(-77.202 -393.686)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15801",
    "data-name": "Trazado 15801",
    d: "M0,0H8.887V3.433H3.433A3.433,3.433,0,0,1,0,0H0Z",
    transform: "matrix(-0.966, -0.257, 0.257, -0.966, 30.47, 133.226)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15802",
    "data-name": "Trazado 15802",
    d: "M310.814,550.2H306.5a1.091,1.091,0,0,1-1.09-.99l-2.619-27.2a.864.864,0,0,0-1.689-.165l-7.6,25.416a1.094,1.094,0,0,1-1.315.749l-4.014-1a1.095,1.095,0,0,1-.8-1.335c.066-.256,6.553-25.607,6.609-25.868,1.47-10.833,3.228-13.735,4.173-15.295.078-.129.15-.248.215-.36.081-.14.579-1.532.9-2.437a1.1,1.1,0,0,1,.562-.687c3.969-2.03,8.614-.625,9.943-.146a1.08,1.08,0,0,1,.539.419c3.986,6.013,2.03,40.936,1.6,47.876A1.1,1.1,0,0,1,310.814,550.2Z",
    transform: "translate(-264.696 -421.668)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15805",
    "data-name": "Trazado 15805",
    d: "M411.165,444.971a2.319,2.319,0,0,1-3.433.929l-7.18,3.721.317-3.161,6.365-3.939a2.332,2.332,0,0,1,3.93,2.45Z",
    transform: "translate(-351.798 -376.802)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15806",
    "data-name": "Trazado 15806",
    d: "M362.321,439.621l-7,3.024a2.954,2.954,0,0,1-2.878-.309l-8.9-6.377a2.388,2.388,0,1,1,2.868-3.818l7.631,6.006,6.066-2.347Z",
    transform: "translate(-307.171 -369.1)",
    fill: "#6b67c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15808",
    "data-name": "Trazado 15808",
    d: "M469.31,530.918h-2.828l-1.345-10.906h4.173Z",
    transform: "translate(-357.859 -400.077)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15809",
    "data-name": "Trazado 15809",
    d: "M450.759,563.8h5.453v3.433h-8.887A3.433,3.433,0,0,1,450.759,563.8Z",
    transform: "translate(-344.155 -433.763)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15810",
    "data-name": "Trazado 15810",
    d: "M544.406,520.32l-2.572,1.175-5.755-9.361,3.8-1.734Z",
    transform: "translate(-412.439 -392.681)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15811",
    "data-name": "Trazado 15811",
    d: "M3.433,0H8.887V3.433H0A3.433,3.433,0,0,1,3.433,0Z",
    transform: "translate(124.099 130.345) rotate(-24.548)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15812",
    "data-name": "Trazado 15812",
    d: "M713.148,531.347a2.319,2.319,0,0,0,.185-3.552l3.324-7.542-4.223.716-2.509,7.052a2.332,2.332,0,0,0,3.223,3.326Z",
    transform: "translate(-589.414 -437.279)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15813",
    "data-name": "Trazado 15813",
    d: "M654.223,577.181h-2.7a1.042,1.042,0,0,1-1.035-.963l-1.473-39.337a1.038,1.038,0,0,1,1.136-1.108l15.622,1.659a1.038,1.038,0,0,1,.937,1.013l.327,17.352a.8.8,0,0,0,.054.275l6.408,16.618a1.038,1.038,0,0,1-.61,1.347l-2.737,1.009a1.038,1.038,0,0,1-1.282-.5L661,559.24a1.029,1.029,0,0,1-.093-.263l-1.345-6.479a.807.807,0,0,0-1.592.072l-2.713,23.692A1.038,1.038,0,0,1,654.223,577.181Z",
    transform: "translate(-542.952 -449.215)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15814",
    "data-name": "Trazado 15814",
    d: "M658.039,449.8a20.219,20.219,0,0,1-10.811-3.275l-.055-.038.006-.067,2.167-25.236a3.557,3.557,0,0,1,3.367-3.243c2.808-.129,6.58.034,8.6,1.538a9.847,9.847,0,0,1,4.035,9.39c-1.01,7.661.134,18,.268,19.15l.01.083-.076.035A17.82,17.82,0,0,1,658.039,449.8Z",
    transform: "translate(-541.538 -358.537)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15815",
    "data-name": "Trazado 15815",
    d: "M713.63,467.5a1.155,1.155,0,0,1-.849-.374l-1.239-1.352a1.159,1.159,0,0,1-.256-1.106l2.825-9.563-4.3-9.028a2.032,2.032,0,0,1,3.623-1.837l5.834,9.466a2.757,2.757,0,0,1,.166,2.583l-4.753,10.532a1.15,1.15,0,0,1-.869.664A1.164,1.164,0,0,1,713.63,467.5Z",
    transform: "translate(-589.579 -377.974)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15816",
    "data-name": "Trazado 15816",
    d: "M550.722,455.4a2.319,2.319,0,0,0,3.459-.825l8.173,1.06-1.878-3.849L553,451.366a2.332,2.332,0,0,0-2.281,4.031Z",
    transform: "translate(-466.6 -384.14)",
    fill: "#ff998e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15817",
    "data-name": "Trazado 15817",
    d: "M584.012,431.217a3.1,3.1,0,0,1-.425-.029L570.729,429.4a1.278,1.278,0,0,1-.98-.718,1.314,1.314,0,0,1-.073-.191h0a1.283,1.283,0,0,1,.133-1.022l1.064-1.764a1.288,1.288,0,0,1,1.1-.619h0l11.208.013,8.371-7.5a2.268,2.268,0,0,1,3.109,3.3l-8.353,9.29a3.082,3.082,0,0,1-2.293,1.023Z",
    transform: "translate(-481.874 -357.858)",
    fill: "#426d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15819",
    "data-name": "Trazado 15819",
    d: "M359.715,737.673H189.436a.275.275,0,1,1,0-.549H359.715a.275.275,0,1,1,0,.549Z",
    transform: "translate(-189.162 -604.13)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15803",
    "data-name": "Trazado 15803",
    d: "M315.643,446.228l-.041-.039c-.076-.074-7.624-7.468-6.647-14.305.418-2.924,2.784-4.793,6.843-5.4a6.258,6.258,0,0,1,6.919,4.41l4.013,13.719Z",
    transform: "translate(-281.259 -365.08)",
    fill: "#6b67c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15804",
    "data-name": "Trazado 15804",
    d: "M300.592,466.382l-5.378-5.344a3.03,3.03,0,0,1-.8-2.858l2.6-10.591a2.388,2.388,0,1,1,4.61,1.244l-2.741,9.317,4.432,4.76Z",
    transform: "translate(-270.071 -379.975)",
    fill: "#6b67c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_910",
    "data-name": "Grupo 910",
    transform: "translate(-21.498 72.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16045",
    "data-name": "Trazado 16045",
    d: "M156.7,738.213s-4.708.225-4.975-4.29c-.284-4.807,4.164-5.268,6.053-3.324a4.813,4.813,0,0,1,1.539,3.92,1.931,1.931,0,0,1,2.753.271,3.084,3.084,0,0,1,.51,2.819s2.428-.094,2.2,2.027a4.734,4.734,0,0,1-1.743,3.2Z",
    transform: "translate(-13148.187 12086.98)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16057",
    "data-name": "Trazado 16057",
    d: "M205.595,937.969l-.489,5s-1.043,1.35-3.993,1.3a5.207,5.207,0,0,1-2.915-.6l.552-2.5.541-2.442,5.4-.645Z",
    transform: "translate(-13192.777 11895.537)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16058",
    "data-name": "Trazado 16058",
    d: "M215.242,939.31a1.653,1.653,0,0,1-.193.469c-1.364,2.39-4.477,2.629-5.747,2.619l.541-2.442Z",
    transform: "translate(-13203.331 11894.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16046",
    "data-name": "Trazado 16046",
    d: "M153.714,788.252s-3.239,6.016-2.545,9.6,3.933,3.3,5.9,2.777a6.346,6.346,0,0,0,2.95-1.62,2.7,2.7,0,0,0,3.066-.81c1.33-1.562.752-3.528-.231-4.049a2.812,2.812,0,0,0-2.256.116l1.1-1.735s-3.239-9.544-7.982-4.28",
    transform: "translate(-13147.202 12034.497)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16059",
    "data-name": "Trazado 16059",
    d: "M165.047,895.513a.218.218,0,0,0,.11-.029l1.984-1.152a.219.219,0,1,0-.22-.378l-1.984,1.152a.219.219,0,0,0,.11.408",
    transform: "translate(-13151.711 11935.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16060",
    "data-name": "Trazado 16060",
    d: "M170.521,904.666a.219.219,0,0,0,.1-.413l-1.01-.527a.219.219,0,0,0-.2.388l1.01.527a.217.217,0,0,0,.1.025",
    transform: "translate(-13155.565 11927.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16047",
    "data-name": "Trazado 16047",
    d: "M267.318,827.694a.217.217,0,0,0,.122-.037.976.976,0,0,1,1.094,0,.219.219,0,0,0,.257-.354,1.413,1.413,0,0,0-1.595,0,.219.219,0,0,0,.122.4",
    transform: "translate(-13261.683 11997.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16048",
    "data-name": "Trazado 16048",
    d: "M266,862.935a.212.212,0,0,0,.042,0,.218.218,0,0,0,.173-.256,3.763,3.763,0,0,1,.732-3.094.219.219,0,1,0-.323-.295,4.157,4.157,0,0,0-.838,3.472.219.219,0,0,0,.215.177",
    transform: "translate(-13259.694 11967.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16049",
    "data-name": "Trazado 16049",
    d: "M283.2,852.828a.218.218,0,0,0,.218-.209l.051-1.194a.219.219,0,0,0-.437-.019l-.051,1.194a.218.218,0,0,0,.209.228h.01",
    transform: "translate(-13277.569 11975.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16050",
    "data-name": "Trazado 16050",
    d: "M242.937,856.672a.219.219,0,0,0,.218-.209l.051-1.194a.219.219,0,0,0-.209-.228.216.216,0,0,0-.228.209l-.051,1.194a.218.218,0,0,0,.209.228h.01",
    transform: "translate(-13234.022 11971.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16051",
    "data-name": "Trazado 16051",
    d: "M162.468,772.739a2.122,2.122,0,0,1,1.89-.839,2.711,2.711,0,0,1,1.892,1.064,3.085,3.085,0,0,0,.835,3.33,4.167,4.167,0,0,0,2.932,1.1l1.274-.318,1.079-1.71-3.186-4.186-4.371-2.884-2.557,1.9Z",
    transform: "translate(-13156.62 12051.373)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16052",
    "data-name": "Trazado 16052",
    d: "M245.332,906.716a1.835,1.835,0,0,0,1.637-.9.219.219,0,1,0-.376-.223,1.481,1.481,0,0,1-1.509.664.219.219,0,0,0-.083.43,1.843,1.843,0,0,0,.331.027",
    transform: "translate(-13237.986 11925.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16053",
    "data-name": "Trazado 16053",
    d: "M278.427,843.834a2.2,2.2,0,1,0-2.132-2.2,2.167,2.167,0,0,0,2.132,2.2m0-3.955a1.76,1.76,0,1,1-1.694,1.759,1.729,1.729,0,0,1,1.694-1.759",
    transform: "translate(-13274.112 11986.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16054",
    "data-name": "Trazado 16054",
    d: "M215.62,849.828a2.2,2.2,0,1,0-2.2-2.2,2.2,2.2,0,0,0,2.2,2.2m0-3.955a1.759,1.759,0,1,1-1.759,1.759,1.761,1.761,0,0,1,1.759-1.759",
    transform: "translate(-13206.241 11980.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16055",
    "data-name": "Trazado 16055",
    d: "M261.072,865.89a.219.219,0,0,0,.018-.437l-1.546-.126a.219.219,0,0,0-.035.436l1.546.126h.018",
    transform: "translate(-13253.459 11962.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16061",
    "data-name": "Trazado 16061",
    d: "M176.333,867.944a.219.219,0,0,0,.159-.369c-1.176-1.25-3.475-.095-3.573-.045a.219.219,0,0,0,.2.39c.021-.011,2.1-1.056,3.055-.045a.219.219,0,0,0,.159.069",
    transform: "translate(-13161.664 11960.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16062",
    "data-name": "Trazado 16062",
    d: "M199.8,994.124a7.714,7.714,0,0,0,4.649-1.529.219.219,0,0,0-.259-.353,7.951,7.951,0,0,1-8.072.6.219.219,0,0,0-.209.384,8.99,8.99,0,0,0,3.891.894",
    transform: "translate(-13191.523 11845.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16056",
    "data-name": "Trazado 16056",
    d: "M226.244,830.756a.219.219,0,0,0,.185-.335,1.572,1.572,0,0,0-1.94-.71.219.219,0,0,0,.169.4,1.141,1.141,0,0,1,1.4.539.218.218,0,0,0,.185.1",
    transform: "translate(-13215.779 11995.062)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_911",
    "data-name": "Grupo 911",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16064",
    "data-name": "Trazado 16064",
    d: "M3085.448,147.868a4.066,4.066,0,0,0-2.87.673,4.151,4.151,0,0,0-1.666,2.8c-.6,3.424.629,4.371-1.328,5.66s-3.064.5-4.3,3.687.664,7.46,4.622,6.6,13.553-3.48,13.553-3.48l.446-14.181-4.8-1.293Z",
    transform: "translate(-16185.8 12751.265)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16069",
    "data-name": "Trazado 16069",
    d: "M3014.683,80.939s1.906-3.091,1.757-4.422c-.366-3.28-4.969-5.554-9.565-4.009s-5.536,7.255-4.818,9.741c1.848,6.4,7.436,4.179,7.436,4.179s8.687-1.616,5.191-5.49",
    transform: "translate(-16102.544 12821.064)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16065",
    "data-name": "Trazado 16065",
    d: "M3049.349,253.078l-.01.119-.258,2.237-.2,1.755s.121.42-1.918.143c-2.732-.382-3.534-1.624-3.534-1.624l.174-4.133.821.217Z",
    transform: "translate(-16138.746 12655.757)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16066",
    "data-name": "Trazado 16066",
    d: "M3048.461,255.816l-.258,2.237c-1.322-.256-3.71-1-4.543-3.172a1.731,1.731,0,0,1-.11-.462l4.906,1.362Z",
    transform: "translate(-16137.867 12653.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16067",
    "data-name": "Trazado 16067",
    d: "M3016.838,115.48s2.142,6.023.991,9.242-4.106,2.491-5.851,1.73a5.937,5.937,0,0,1-2.5-1.917,2.686,2.686,0,0,1-1.932-4.9,2.632,2.632,0,0,1,2.07.427l-.769-1.761s4.35-8.367,7.989-2.825",
    transform: "translate(-16104.617 12782.795)",
    fill: "#fca397"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16070",
    "data-name": "Trazado 16070",
    d: "M3028.9,197.765a.211.211,0,0,0,.2-.135,3.349,3.349,0,0,0-.334-2.637.213.213,0,0,0-.366.218,2.973,2.973,0,0,1,.3,2.263.212.212,0,0,0,.119.276.216.216,0,0,0,.079.015",
    transform: "translate(-16117.462 12707.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16071",
    "data-name": "Trazado 16071",
    d: "M3118.605,204a.212.212,0,0,0,.165-.347l-1.456-1.8a.213.213,0,1,0-.331.267l1.457,1.8a.21.21,0,0,0,.165.079",
    transform: "translate(-16214.049 12701.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16072",
    "data-name": "Trazado 16072",
    d: "M3123.881,216.659l1.126-.082a.213.213,0,0,0,.2-.228.221.221,0,0,0-.228-.2l-1.11.082a.213.213,0,0,0,.015.425",
    transform: "translate(-16220.971 12688.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16073",
    "data-name": "Trazado 16073",
    d: "M3044.019,231.761a1.834,1.834,0,0,0,1.074-.434.213.213,0,0,0-.058-.356l-2.225-.935a.213.213,0,0,0-.291.24,2.2,2.2,0,0,0,.924,1.326,1.1,1.1,0,0,0,.575.16m.48-.554a.863.863,0,0,1-.836.029,1.552,1.552,0,0,1-.559-.616Z",
    transform: "translate(-16134.489 12675.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16074",
    "data-name": "Trazado 16074",
    d: "M3056.7,163.992a.214.214,0,0,0,.181-.1c.293-.477.973-.285,1-.277a.214.214,0,0,0,.264-.144.211.211,0,0,0-.143-.264,1.339,1.339,0,0,0-1.485.462.212.212,0,0,0,.181.324",
    transform: "translate(-16148.586 12737.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16075",
    "data-name": "Trazado 16075",
    d: "M3016.374,160.259a.213.213,0,0,0,.153-.361,1.543,1.543,0,0,0-.992-.455.909.909,0,0,0-.671.366.213.213,0,0,0,.332.267.482.482,0,0,1,.359-.207,1.054,1.054,0,0,1,.666.326.213.213,0,0,0,.153.065",
    transform: "translate(-16103.712 12740.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16076",
    "data-name": "Trazado 16076",
    d: "M3015.981,177.719a.215.215,0,0,0,.212-.227l-.069-1,.389-.413a.213.213,0,1,0-.309-.292l-.453.48a.21.21,0,0,0-.058.161l.076,1.1a.213.213,0,0,0,.212.2",
    transform: "translate(-16103.766 12725.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16077",
    "data-name": "Trazado 16077",
    d: "M3059.393,176.944a.215.215,0,0,0,.212-.223l-.049-.993.572-.483a.213.213,0,0,0-.274-.325l-.653.551a.211.211,0,0,0-.075.173l.055,1.1a.213.213,0,0,0,.213.2",
    transform: "translate(-16150.846 12726.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16079",
    "data-name": "Trazado 16079",
    d: "M3156.76,49.652s.8-7-4.012-6.353c-5.094.686-.5,8.9,2.752,8.535,1.449-.162,1.26-2.182,1.26-2.182",
    transform: "translate(-16254.703 12847.539)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16068",
    "data-name": "Trazado 16068",
    d: "M3046.647,308.635c.158,0,.254,0,.274-.005a.213.213,0,0,0,.2-.223.208.208,0,0,0-.223-.2,10.914,10.914,0,0,1-5.372-1.295.213.213,0,0,0-.217.366,11.037,11.037,0,0,0,5.336,1.359",
    transform: "translate(-16136.343 12604.841)",
    fill: "#f7734f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16080",
    "data-name": "Trazado 16080",
    d: "M3147.855,96.162a.213.213,0,0,0,.212-.192,5.193,5.193,0,0,1,2.354-4.131.213.213,0,1,0-.195-.378,5.539,5.539,0,0,0-2.583,4.468.213.213,0,0,0,.191.233h.021",
    transform: "translate(-16248.207 12803.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16078",
    "data-name": "Trazado 16078",
    d: "M3054.483,106.214a4.777,4.777,0,0,1,.826,2.444l.1,1.508-6.245,1.82-.126-3.022Z",
    transform: "translate(-16145.249 12789.578)",
    fill: "#e56445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16081",
    "data-name": "Trazado 16081",
    d: "M3015.97,97.706a3.258,3.258,0,0,1,.8,1.119,16.256,16.256,0,0,1,.507,1.913l1.808-.2-.207-3.156-2.438-1.493-1.473.165.228,2.033Z",
    transform: "translate(-16106.219 12799.086)",
    fill: "#e56445"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16082",
    "data-name": "Trazado 16082",
    d: "M315.643,446.228l-.041-.039c-.076-.074-7.624-7.468-6.647-14.305.418-2.924,2.784-4.793,6.843-5.4a6.258,6.258,0,0,1,6.919,4.41l4.013,13.719Z",
    transform: "translate(-13408.015 12485.148)",
    fill: "#6b67c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16083",
    "data-name": "Trazado 16083",
    d: "M300.592,466.382l-5.378-5.344a3.03,3.03,0,0,1-.8-2.858l2.6-10.591a2.388,2.388,0,1,1,4.61,1.244l-2.741,9.317,4.432,4.76Z",
    transform: "translate(-13396.825 12470.253)",
    fill: "#6b67c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.488b2f6472de6eae5436c77149259ea1.svg";
export { ForwardRef as ReactComponent };